<div class="btn-create-new">
  <button (click)="addNew()" title="Add new"></button>
</div>
